import coloredMasterCard from "@/assets/images/bank-card/icon-colored-master-card.svg";
import yeatiLogo from "@/assets/images/yeati-logo.png";
import { ScanningOverlay } from "@/features/card/components/CardManager/PaymentCard/ScanningOverlay";
import type { EnhancedCard } from "@/features/card/types/card.type";
import { cn } from "@/shared/utils/style.util";

type PaymentCardProps = {
  dataTestId: string
  data: EnhancedCard & { isActive: boolean }
  isScanning?: boolean
};

export const PaymentCard = ({ dataTestId, data, isScanning = false }: PaymentCardProps) => {
  return (
    <div
      data-testid={dataTestId}
      className="relative w-full h-full min-w-[244px] max-w-[310px] aspect-[287/168]"
    >
      {isScanning && (<ScanningOverlay />)}
      <div
        className={cn(
          "font-mono text-base text-lightgray dark:text-dark",
          "relative flex flex-col justify-between gap-2 w-full min-w-[244px] max-w-[310px] h-full aspect-[287/168] rounded-md py-3 px-4 shadow-lg border-1 transition-all duration-200",
          "border-black border-t-gray-emphasis dark:border-lightmuted dark:border-t-white",
          "bg-linear-[165deg] from-darkgray via-darkmuted to-dark",
          "dark:bg-linear-[165deg] dark:from-bgmuted dark:via-light-emphasis dark:to-gray-emphasis",
          !data.isActive && "opacity-50 shadow-none before:content-[''] before:absolute before:opacity-100 before:inset-0 before:bg-[repeating-linear-gradient(-45deg,transparent,transparent_20px,rgba(128,128,128,0.6)_20px,rgba(128,128,128,0.6)_40px)] before:dark:bg-[repeating-linear-gradient(45deg,transparent,transparent_20px,rgba(64,64,64,0.6)_20px,rgba(64,64,64,0.6)_40px)] before:rounded-md before:pointer-events-none before:z-10",
        )}
      >
        <div className="flex flex-row justify-between items-end gap-2">
          <h5 className="whitespace-nowrap text-sm">{data.formattedCardNumber}</h5>
          <img
            src={yeatiLogo}
            alt="yeati logo"
            className="min-w-[40px] max-w-[70px] aspect-auto object-cover grayscale-100 brightness-200 dark:brightness-20"
          />
        </div>
        <h5 className="flex-1 text-lg">
          {data.embossed_name.toUpperCase()}
        </h5>
        <div className="flex flex-row justify-between items-end">
          <h5>
            <span className="text-sm mr-3">Expiration</span>
            {`${data.expireAt.month}/${data.expireAt.shortYear}`}
          </h5>
          <img
            src={coloredMasterCard}
            alt="icon"
            width={45}
            height={58}
          />
        </div>
      </div>
    </div>
  );
};
